<template>
  <div>
    <v-card
      elevation="1"
      class="card card-mobile"
      flat
      style="margin-left: 3rem; margin-right: 1rem; border-radius: 15px"
    >
      <v-system-bar height="60px" class="card-header-systembar">
        <label
          class="ml-5 my-5"
          style="color: #444444; font-size: 20px !important"
        >
          {{ $t("report") }}
        </label>
      </v-system-bar>
      <v-layout row align-center class="ml-7 mt-10" style="margin-bottom: 12px;">
        <v-flex xs8 sm6 md6 lg4 xl2>
          <title-block
            :relative="this.$vuetify.breakpoint.name !== 'xs' ? true : false"
            width="300"
            height="60"
            class="report-title-text-mobile"
          >
            {{ $t("report") }}</title-block
          >
        </v-flex>
      </v-layout>

      <v-layout row wrap class="ml-7 mt-5">
        <v-row class="mr-0" style="margin-bottom: 18px;">
          <v-col style="display: flex; flex-direction: row;" class="py-0">
            <v-btn
              outlined
              class="text"
              width="170"
              @click="onClickRunning"
              :style="{
                'border-radius': '5px 0 0 5px',
                height: '40px',
                'text-transform': 'none',
                'background-color': active.backcolor,
                color: active.color,
                border: active.border
              }"
              >{{ $t("active") }}</v-btn
            >
            <v-btn
              class="text"
              width="170"
              outlined
              @click="onClickRemoved"
              :style="{
                'border-radius': '0 5px 5px 0',
                height: '40px',
                'text-transform': 'none',
                'background-color': inactive.backcolor,
                color: inactive.color,
                border: inactive.border
              }"
              >{{ $t("inactive") }}</v-btn
            >
          </v-col>
          <v-col
            class="py-0"
            style="display: flex;justify-content: end;padding-right: 2.4rem;"
          >
            <v-form>
              <v-text-field
                v-model="search"
                outlined
                :autofocus="'autofocus'"
                dense
                color="#2f9a61"
                :placeholder="$t('searchcodenamemailph')"
                class="text"
                style="border-color: #d9d9d9; height: 40px; width: 300px"
              >
                <v-icon slot="append" class="searchicon">mdi-magnify</v-icon>
              </v-text-field>
            </v-form>
          </v-col>
        </v-row>
      </v-layout>

      <v-row class="ma-1 px-2">
        <v-col cols="12" class="py-0">
          <v-row class="d-flex">
            <v-col cols="12" lg="2" class="py-0">
              <label
                style="
                  font-size: 16px;
                  color: #424242;
                  font-weight: bold;
                  margin-top: 5px;
                "
                >{{ $t("registrationDate") }}</label
              >
              <v-menu
                v-model="frommenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="startdate"
                    prepend-inner-icon="mdi-calendar-blank-outline"
                    outlined
                    dense
                    readonly
                    v-bind="attrs"
                    placeholder="yyyy/mm/dd"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="startdate"
                  @input="frommenu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" lg="2" class="py-0">
              <label
                style="
                  font-size: 16px;
                  color: #47484b;
                  font-weight: bold;
                  margin-top: 5px;
                "
                >{{ $t("to") }}
              </label>
              <v-menu
                v-model="tomenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="enddate"
                    prepend-inner-icon="mdi-calendar-blank-outline"
                    outlined
                    dense
                    placeholder="yyyy/mm/dd"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="enddate"
                  :allowed-dates="allowedEndDates"
                  @input="tomenu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row class="ma-1 px-2">
        <v-col cols="12" class="pt-1 pb-1">
          <v-row class="d-flex">
            <v-col cols="12" lg="2" class="py-0">
              <label
                style="
                  font-size: 16px;
                  color: #424242;
                  font-weight: bold;
                  margin-top: 5px;
                "
                >{{ $t("expirydate") }}</label
              >
              <v-menu
                v-model="viewfrom"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="viewstartdate"
                    prepend-inner-icon="mdi-calendar-blank-outline"
                    outlined
                    dense
                    readonly
                    placeholder="yyyy/mm/dd"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="viewstartdate"
                  @change="viewfrom = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" lg="2" class="py-0">
              <label
                style="
                  font-size: 16px;
                  color: #424242;
                  font-weight: bold;
                  margin-top: 5px;
                "
                >{{ $t("to") }}</label
              >
              <v-menu
                v-model="viewto"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="viewenddate"
                    prepend-inner-icon="mdi-calendar-blank-outline"
                    outlined
                    dense
                    readonly
                    placeholder="yyyy/mm/dd"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="viewenddate"
                  :allowed-dates="allowedviewEndDates"
                  @change="viewto = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col
              cols="12"
              lg="4"
              xl="4"
              style="padding-top: 2.1rem"
              class="pb-0"
            >
              <v-btn
                text
                class="text-capitalize"
                height="40"
                style="
                  border: 1px solid #c0c0c0;
                  border-radius: 8px;
                  color: #424242;
                  font-size: 16px;
                "
                @click="clearAll()"
                >{{ "Clear All" }}</v-btn
              >
              <v-btn
                width="120"
                height="40"
                class="text-capitalize btn_hover_effect ml-5"
                style="
                  color: #ffff;
                  border: 1px solid #a6cc39;
                  border-radius: 8px;
                  font-size: 16px;
                "
                color="#A6CC39"
                @click="GetFilteredResult()"
                >{{ $t("search") }}</v-btn
              >
            </v-col>
            <v-col
              cols="12"
              lg="4"
              xl="4"
              style="padding-top: 2.1rem; display: flex; justify-content: end"
              class="pb-0"
            >
              <v-btn
                width="200"
                color="#6cc8a0"
                dark
                class="text-capitalize"
                @click="exportExcelReport"
              >
                {{ $t("exportexcel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-data-table
        :mobile-breakpoint="0"
        :headers="headers"
        :items="current == 'active' ? activeData : inactiveData"
        @current-items="getFiltered"
        hide-default-footer
        :page.sync="page"
        :items-per-page="search ? totalCount : itemsPerPage"
        @page-count="pageCount = $event"
        :search="search"
        :key="sortTable"
        :must-sort="true"
        class="usertable p-horizontal my-5 mx-7"
      >
      </v-data-table>

      <!-- ******** pagination, perpage -->
      <v-layout
        row="wrap"
        align-center
        class="mt-5"
        style="margin-right: -30px"
      >
        <v-spacer />
        <v-flex my-3 mr-5 style="min-width: 240px; max-width: 315px">
          <v-pagination
            v-model="page"
            :length="pageCount"
            :total-visible="5"
            color="#E8E9EC"
          ></v-pagination>
        </v-flex>

        <v-flex shrink my-3 style="min-width: 173px">
          <select
            style="border:1px solid;border-color:#D9D9D9;border-radius:5pt; padding:5px;opacity:0.5;
            background-color: #FFFFFF;width:110px;color:#4D4F5C;box-shadow: 0px 1px 1px #00000029;height:36px;"
            class="perPageText"
            v-model="itemsPerPage"
          >
            <option value="10">10 of {{ totalCount }}</option>
            <option value="15">15 of {{ totalCount }}</option>
            <option value="20">20 of {{ totalCount }}</option>
            <option value="25">25 of {{ totalCount }}</option>
          </select>
          <span>
            <v-icon style="margin: 0.5rem 0 0 -2rem; vertical-align: top"
              >mdi-chevron-down</v-icon
            >
          </span>
        </v-flex>
      </v-layout>
    </v-card>
    <v-dialog v-model="dialog" persistent width="300">
      <v-card color="#FFF4EB" dark>
        <v-card-text class="black--text">
          Loading Please Wait...
          <v-progress-linear
            indeterminate
            color="#6CC8A0"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import exceljs from "exceljs";
import { saveAs } from "file-saver";
import axios from "axios";
import enurl from "@/api/environment";
import TitleBlock from "@/components/global_component/TitleBlock";
import * as moment from "moment/moment";

export default {
  name: "report",
  components: {
    TitleBlock
  },

  data() {
    return {
      startdate: "",
      enddate: "",
      frommenu: false,
      tomenu: false,
      viewfrom: false,
      viewto: false,
      viewstartdate: "",
      viewenddate: "",
      filteredItems: [],
      url: enurl.apiUrl,
      dialog: false,
      sortTable: 1,
      activeData: [],
      inactiveData: [],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      totalCount: "",
      current: "active",
      search: "",
      inactive: {
        color: "#6CC8A0",
        backcolor: "#F0F0F7",
        border: "1px solid #6CC8A0"
      },
      active: {
        color: "#fff",
        backcolor: "#6CC8A0",
        border: "1px solid #6CC8A0"
      }
    };
  },

  computed: {
    headers() {
      let self = this;
      if (self.current == "active") {
        return [
          {
            text: this.$t("abbre"),
            align: "left",
            value: "companyCode",
            width: "150px"
          },
          {
            text: this.$t("companyname"),
            align: "left",
            value: "companyName",
            width: "227px"
          },
          {
            text: this.$t("registrationDate"),
            align: "left",
            value: "createDate",
            width: "150px"
          },
          {
            text: this.$t("expirydate"),
            align: "left",
            value: "expiryDate",
            width: "180px"
          },
          {
            text: this.$t("packagename"),
            align: "left",
            value: "packageName",
            width: "150px"
          },
          {
            text: this.$t("totalEmployee"),
            align: "left",
            value: "totalEmployeesCount",
            width: "150px"
          },
          {
            text: this.$t("activeemployees"),
            align: "left",
            value: "activeEmployeesCount",
            width: "160px"
          },
          {
            text: this.$t("lastloginonweb"),
            align: "left",
            value: "lastLoginWeb",
            width: "160px"
          },
          {
            text: this.$t("useonwebthismonth"),
            align: "left",
            value: "useWebThisMonthCount",
            width: "185px"
          },
          {
            text: this.$t("lastloginonmobile"),
            align: "left",
            value: "lastLoginMobile",
            width: "180px"
          },
          {
            text: this.$t("useonmobilethismonth"),
            align: "left",
            value: "useMobileThisMonthCount",
            width: "200px"
          },
          {
            text: this.$t("lastloginonuserview"),
            align: "left",
            value: "lastLoginUserview",
            width: "180px"
          },
          {
            text: this.$t("useonuserviewthismonth"),
            align: "left",
            value: "useUserviewThisMonthCount",
            width: "200px"
          },
          {
            text: this.$t("numberofarticles"),
            align: "left",
            value: "numberOfArticlesCount",
            width: "160px"
          },
          {
            text: this.$t("numberofsound"),
            align: "left",
            value: "numberOfSoundCount",
            width: "160px"
          },
          {
            text: this.$t("numberofvideos"),
            align: "left",
            value: "numberOfVideoCount",
            width: "160px"
          },
          {
            text: this.$t("numberoflessonlearn"),
            align: "left",
            value: "numberOfLessonCount",
            width: "200px"
          },
          {
            text: this.$t("numberofquiztopic"),
            align: "left",
            value: "numberOfQuizTopicCount",
            width: "180px"
          },
          {
            text: this.$t("numberofevent"),
            align: "left",
            value: "numberOfEventCount",
            width: "150px"
          },
          {
            text: this.$t("numberofbanner"),
            align: "left",
            value: "numberOfBannerCount",
            width: "160px"
          }
        ];
      } else {
        return [
          {
            text: this.$t("abbre"),
            align: "left",
            value: "companyCode",
            width: "150px"
          },
          {
            text: this.$t("companyname"),
            align: "left",
            value: "companyName",
            width: "227px"
          },
          {
            text: this.$t("registrationDate"),
            align: "left",
            value: "createDate",
            width: "150px"
          },
          {
            text: this.$t("expirydate"),
            align: "left",
            value: "expiryDate",
            width: "180px"
          },
          {
            text: this.$t("packagename"),
            align: "left",
            value: "packageName",
            width: "150px"
          },
          {
            text: this.$t("totalEmployee"),
            align: "left",
            value: "totalEmployeesCount",
            width: "150px"
          },
          {
            text: this.$t("inactiveemployees"),
            align: "left",
            value: "activeEmployeesCount",
            width: "170px"
          },
          {
            text: this.$t("lastloginonweb"),
            align: "left",
            value: "lastLoginWeb",
            width: "160px"
          },
          {
            text: this.$t("useonwebthismonth"),
            align: "left",
            value: "useWebThisMonthCount",
            width: "185px"
          },
          {
            text: this.$t("lastloginonmobile"),
            align: "left",
            value: "lastLoginMobile",
            width: "180px"
          },
          {
            text: this.$t("useonmobilethismonth"),
            align: "left",
            value: "useMobileThisMonthCount",
            width: "200px"
          },
          {
            text: this.$t("lastloginonuserview"),
            align: "left",
            value: "lastLoginUserview",
            width: "180px"
          },
          {
            text: this.$t("useonuserviewthismonth"),
            align: "left",
            value: "useUserviewThisMonthCount",
            width: "200px"
          },
          {
            text: this.$t("numberofarticles"),
            align: "left",
            value: "numberOfArticlesCount",
            width: "160px"
          },
          {
            text: this.$t("numberofsound"),
            align: "left",
            value: "numberOfSoundCount",
            width: "160px"
          },
          {
            text: this.$t("numberofvideos"),
            align: "left",
            value: "numberOfVideoCount",
            width: "160px"
          },
          {
            text: this.$t("numberoflessonlearn"),
            align: "left",
            value: "numberOfLessonCount",
            width: "200px"
          },
          {
            text: this.$t("numberofquiztopic"),
            align: "left",
            value: "numberOfQuizTopicCount",
            width: "180px"
          },
          {
            text: this.$t("numberofevent"),
            align: "left",
            value: "numberOfEventCount",
            width: "150px"
          },
          {
            text: this.$t("numberofbanner"),
            align: "left",
            value: "numberOfBannerCount",
            width: "160px"
          }
        ];
      }
    }
  },

  mounted: function() {
    let self = this;
    self.GetAllActiveData();
    self.GetAllInactiveData();
  },

  methods: {
    async GetFilteredResult() {
      let that = this;
      let request = {
        companyType: that.current,
        registerFromDate: that.startdate,
        registerToDate: that.enddate,
        expiryFromDate: that.viewstartdate,
        expiryToDate: that.viewenddate,
        statusID: null,
        businessTypeIDs: []
      };
      that.dialog = true;
      await axios
        .post(`${that.url}Company/GetReportCompanyFilteredResult`, request)
        .then(function(response) {
          if (response.data.status == 0) {
            let cmpdata = response.data.data.map(v => ({
              ...v,
              createDate: moment(v.createDate)
                .local()
                .format("DD/MM/YYYY"),
              startDate: v.startDate
                ? moment(v.startDate)
                    .local()
                    .format("DD-MM-YYYY")
                : "",
              reminderDate: v.reminderDate
                ? moment(v.reminderDate)
                    .local()
                    .format("DD-MM-YYYY")
                : "",
              expiryDate: v.expiryDate
                ? moment(v.expiryDate)
                    .local()
                    .format("DD/MM/YYYY")
                : "",
              lastLoginWeb: v.lastLoginWeb
                ? moment(v.lastLoginWeb)
                    .local()
                    .format("DD/MM/YYYY")
                : "",
              lastLoginMobile: v.lastLoginMobile
                ? moment(v.lastLoginMobile)
                    .local()
                    .format("DD/MM/YYYY")
                : "",
              lastLoginUserview: v.lastLoginUserview
                ? moment(v.lastLoginUserview)
                    .local()
                    .format("DD/MM?YYYY")
                : ""
            }));

            if (that.current === "active") {
              that.activeData = cmpdata.filter(
                d => d.companyName != "Fusion Solution Test"
              );
            } else {
              that.inactiveData = cmpdata.filter(
                d => d.companyName != "Fusion Solution Test"
              );
            }

            that.totalCount = response.data.data.length;
            that.dialog = false;
          }
        })
        .catch(function(err) {
          that.dialog = false;
          throw err;
        });
    },
    clearAll() {
      this.enddate = "";
      this.startdate = "";
      this.viewstartdate = "";
      this.viewenddate = "";

      if (this.current === "active") {
        this.GetAllActiveData();
      } else {
        this.GetAllInactiveData();
      }
    },
    allowedviewEndDates(val) {
      return val >= this.viewstartdate;
    },
    allowedEndDates(val) {
      return val >= this.startdate;
    },
    getFiltered(e) {
      let self = this;
      self.filteredItems = e;
    },

    // async exportExcelReport() {
    //   try {
    //     let item_temp = [];
    //     let headers = [];

    //     if (this.current === "active") {
    //       item_temp = this.search ? this.filteredItems : this.activeData;
    //       headers = [
    //         "Company Code",
    //         "Company Name",
    //         "Registration Date",
    //         "Expiry Date",
    //         "Package Name",
    //         "Total Employee",
    //         "Active Employees",
    //         "Last Log in on web",
    //         "Use on web this month",
    //         "Last Log in on mobile",
    //         "Use on mobile this month",
    //         "Number of Articles",
    //         "Number of Sound",
    //         "Number of Videos",
    //         "Number of Lesson Learn",
    //         "Number of Quiz Topic",
    //         "Number of Event",
    //         "Number of Banner"
    //       ];
    //     } else {
    //       item_temp = this.search ? this.filteredItems : this.inactiveData;
    //       headers = [
    //         "Company Code",
    //         "Company Name",
    //         "Registration Date",
    //         "Expiry Date",
    //         "Package Name",
    //         "Total Employee",
    //         "Inactive Employees",
    //         "Last Log in on web",
    //         "Use on web this month",
    //         "Last Log in on mobile",
    //         "Use on mobile this month",
    //         "Number of Articles",
    //         "Number of Sound",
    //         "Number of Videos",
    //         "Number of Lesson Learn",
    //         "Number of Quiz Topic",
    //         "Number of Event",
    //         "Number of Banner"
    //       ];
    //     }

    //     const keys = [
    //       "companyCode",
    //       "companyName",
    //       "createDate",
    //       "expiryDate",
    //       "packageName",
    //       "totalEmployeesCount",
    //       this.current === "active"
    //         ? "activeEmployeesCount"
    //         : "inactiveEmployeesCount",
    //       "lastLoginWeb",
    //       "useWebThisMonthCount",
    //       "lastLoginMobile",
    //       "useMobileThisMonthCount",
    //       "numberOfArticlesCount",
    //       "numberOfSoundCount",
    //       "numberOfVideoCount",
    //       "numberOfLessonCount",
    //       "numberOfQuizTopicCount",
    //       "numberOfEventCount",
    //       "numberOfBannerCount"
    //     ];

    //     const filterItems = item_temp.map(x => ({ ...x }));

    //     const workbook = new exceljs.Workbook();
    //     const worksheet = workbook.addWorksheet("Admin Report", {
    //       views: [{ showGridLines: true }]
    //     });

    //     worksheet.addRow(headers);

    //     filterItems.forEach(item => {
    //       const row = keys.map(k => item[k] ?? "");
    //       worksheet.addRow(row);
    //     });

    //     const headerRow = worksheet.getRow(1);
    //     headerRow.height = 22;
    //     headerRow.eachCell(cell => {
    //       cell.fill = {
    //         type: "pattern",
    //         pattern: "solid",
    //         fgColor: { argb: "FFFFFFFF" }
    //       };
    //       cell.font = {
    //         name: "Calibri",
    //         size: 11,
    //         color: { argb: "FF000000" },
    //         bold: true
    //       };
    //       cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    //       cell.border = {
    //         top: { style: "thin", color: { argb: "FFFF0000" } },
    //         left: { style: "thin", color: { argb: "FFFF0000" } },
    //         bottom: { style: "medium", color: { argb: "FFFF0000" } },
    //         right: { style: "thin", color: { argb: "FFFF0000" } }
    //       };
    //     });

    //     worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
    //       if (rowNumber > 1) {
    //         row.eachCell(cell => {
    //           cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    //           cell.border = {
    //             top: { style: "thin", color: { argb: "FFD9D9D9" } },
    //             left: { style: "thin", color: { argb: "FFD9D9D9" } },
    //             bottom: { style: "thin", color: { argb: "FFD9D9D9" } },
    //             right: { style: "thin", color: { argb: "FFD9D9D9" } }
    //           };
    //         });
    //       }
    //     });

    //     worksheet.columns.forEach((col, i) => {
    //       const headerText = headers[i] || "";
    //       col.width = headerText.length + 15;
    //     });

    //     const fileName = "AdminReport.xlsx";
    //     const buffer = await workbook.xlsx.writeBuffer();
    //     const blob = new Blob([buffer], {
    //       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
    //     });
    //     saveAs(blob, fileName);

    //   } catch (err) {
    //     console.error("❌ Excel export error:", err);
    //   }
    // }

    async exportExcelReport() {
      try {
        let item_temp = [];
        let headers = [];

        if (this.current === "active") {
          item_temp = this.search ? this.filteredItems : this.activeData;
          headers = [
            "Company Code",
            "Company Name",
            "Registration Date",
            "Expiry Date",
            "Package Name",
            "Total Employee",
            "Active Employees",
            "Last Log in on web",
            "Use on web this month",
            "Last Log in on mobile",
            "Use on mobile this month",
            "Number of Articles",
            "Number of Sound",
            "Number of Videos",
            "Number of Lesson Learn",
            "Number of Quiz Topic",
            "Number of Event",
            "Number of Banner"
          ];
        } else {
          item_temp = this.search ? this.filteredItems : this.inactiveData;
          headers = [
            "Company Code",
            "Company Name",
            "Registration Date",
            "Expiry Date",
            "Package Name",
            "Total Employee",
            "Inactive Employees",
            "Last Log in on web",
            "Use on web this month",
            "Last Log in on mobile",
            "Use on mobile this month",
            "Number of Articles",
            "Number of Sound",
            "Number of Videos",
            "Number of Lesson Learn",
            "Number of Quiz Topic",
            "Number of Event",
            "Number of Banner"
          ];
        }

        const keys = [
          "companyCode",
          "companyName",
          "createDate",
          "expiryDate",
          "packageName",
          "totalEmployeesCount",
          this.current === "active"
            ? "activeEmployeesCount"
            : "inactiveEmployeesCount",
          "lastLoginWeb",
          "useWebThisMonthCount",
          "lastLoginMobile",
          "useMobileThisMonthCount",
          "numberOfArticlesCount",
          "numberOfSoundCount",
          "numberOfVideoCount",
          "numberOfLessonCount",
          "numberOfQuizTopicCount",
          "numberOfEventCount",
          "numberOfBannerCount"
        ];

        const filterItems = item_temp.map(x => ({ ...x }));

        const workbook = new exceljs.Workbook();
        const worksheet = workbook.addWorksheet("Admin Report", {
          views: [{ showGridLines: true }]
        });

        worksheet.addRow(headers);

        filterItems.forEach(item => {
          const row = keys.map(k => item[k] ?? "");
          worksheet.addRow(row);
        });

        const headerRow = worksheet.getRow(1);
        headerRow.height = 22;
        headerRow.eachCell(cell => {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFF2F2F2" }
          };
          cell.font = {
            name: "Calibri",
            size: 11,
            color: { argb: "FF000000" },
            bold: true
          };
          cell.alignment = {
            vertical: "middle",
            horizontal: "center",
            wrapText: true
          };
          cell.border = {
            top: { style: "thin", color: { argb: "FFD9D9D9" } },
            left: { style: "thin", color: { argb: "FFD9D9D9" } },
            bottom: { style: "thin", color: { argb: "FFD9D9D9" } },
            right: { style: "thin", color: { argb: "FFD9D9D9" } }
          };
        });

        worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
          if (rowNumber > 1) {
            row.eachCell(cell => {
              cell.alignment = {
                vertical: "middle",
                horizontal: "center",
                wrapText: true
              };
              cell.border = {
                top: { style: "thin", color: { argb: "FFE0E0E0" } },
                left: { style: "thin", color: { argb: "FFE0E0E0" } },
                bottom: { style: "thin", color: { argb: "FFE0E0E0" } },
                right: { style: "thin", color: { argb: "FFE0E0E0" } }
              };
            });
          }
        });

        worksheet.columns.forEach((col, i) => {
          const headerText = headers[i] || "";
          col.width = headerText.length + 15;
        });

        const fileName = "AdminReport.xlsx";
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
        });
        saveAs(blob, fileName);
      } catch (err) {
        console.error("❌ Excel export error:", err);
      }
    },
    GetAllActiveData() {
      let self = this;
      self.dialog = true;
      axios
        .get(`${self.url}Company/GetReportCompanyActive`)
        .then(function(response) {
          self.dialog = false;
          let cmpdata = response.data.data.map(v => ({
            ...v,
            createDate: moment(v.createDate)
              .local()
              .format("DD/MM/YYYY"),
            startDate: v.startDate
              ? moment(v.startDate)
                  .local()
                  .format("DD-MM-YYYY")
              : "",
            reminderDate: v.reminderDate
              ? moment(v.reminderDate)
                  .local()
                  .format("DD-MM-YYYY")
              : "",
            expiryDate: v.expiryDate
              ? moment(v.expiryDate)
                  .local()
                  .format("DD/MM/YYYY")
              : "",
            lastLoginWeb: v.lastLoginWeb
              ? moment(v.lastLoginWeb)
                  .local()
                  .format("DD/MM/YYYY")
              : "",
            lastLoginMobile: v.lastLoginMobile
              ? moment(v.lastLoginMobile)
                  .local()
                  .format("DD/MM/YYYY")
              : "",
            lastLoginUserview: v.lastLoginUserview
              ? moment(v.lastLoginUserview)
                  .local()
                  .format("DD/MM/YYYY")
              : ""
          }));
          self.activeData = cmpdata.filter(
            d => d.companyName != "Fusion Solution Test"
          );
          self.totalCount = response.data.data.length;
        })
        .catch(function(error) {
          self.dialog = false;
        });
    },

    GetAllInactiveData() {
      let self = this;
      self.dialog = true;
      axios
        .get(`${self.url}Company/GetReportCompanyInactive`)
        .then(function(response) {
          self.dialog = false;
          let cmpdata = response.data.data.map(v => ({
            ...v,
            createDate: moment(v.createDate)
              .local()
              .format("DD/MM/YYYY"),
            startDate: v.startDate
              ? moment(v.startDate)
                  .local()
                  .format("DD-MM-YYYY")
              : "",
            reminderDate: v.reminderDate
              ? moment(v.reminderDate)
                  .local()
                  .format("DD-MM-YYYY")
              : "",
            expiryDate: v.expiryDate
              ? moment(v.expiryDate)
                  .local()
                  .format("DD/MM/YYYY")
              : "",
            lastLoginWeb: v.lastLoginWeb
              ? moment(v.lastLoginWeb)
                  .local()
                  .format("DD/MM/YYYY")
              : "",
            lastLoginMobile: v.lastLoginMobile
              ? moment(v.lastLoginMobile)
                  .local()
                  .format("DD/MM/YYYY")
              : "",
            lastLoginUserview: v.lastLoginUserview
              ? moment(v.lastLoginUserview)
                  .local()
                  .format("DD/MM/YYYY")
              : ""
          }));
          self.inactiveData = cmpdata.filter(
            d => d.companyName != "Fusion Solution Test"
          );
          self.totalCount = response.data.data.length;
        })
        .catch(function(error) {
          self.dialog = false;
        });
    },

    resetOnTabChange() {
      let self = this;
      self.search = null;
      self.page = 1;
    },
    onClickRunning() {
      let self = this;
      self.startdate = "";
      self.enddate = "";
      self.viewstartdate = "";
      self.viewenddate = "";
      self.resetOnTabChange();
      self.GetAllActiveData();
      self.current = "active";
      self.active = {
        color: "#fff",
        backcolor: "#6CC8A0",
        border: "1px solid #6CC8A0"
      };
      self.page = 1;
      self.inactive = {
        color: "#6CC8A0",
        backcolor: "#F0F0F7",
        border: "1px solid #6CC8A0"
      };
      self.sortTable = 1;
      self.table = true;
    },
    onClickRemoved() {
      let self = this;
      self.startdate = "";
      self.enddate = "";
      self.viewstartdate = "";
      self.viewenddate = "";
      self.resetOnTabChange();
      self.GetAllInactiveData();
      self.current = "inactive";
      self.inactive = {
        color: "#fff",
        backcolor: "#6CC8A0",
        border: "1px solid #6CC8A0"
      };
      self.active = {
        color: "#6CC8A0",
        backcolor: "#F0F0F7",
        border: "1px solid #6CC8A0"
      };
    }
  }
};
</script>
